import { render, staticRenderFns } from "./TotalDecisionMakers.vue?vue&type=template&id=485fe459&scoped=true&"
import script from "./TotalDecisionMakers.vue?vue&type=script&lang=ts&"
export * from "./TotalDecisionMakers.vue?vue&type=script&lang=ts&"
import style0 from "./TotalDecisionMakers.vue?vue&type=style&index=0&id=485fe459&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485fe459",
  null
  
)

export default component.exports